import { Component, Input, OnInit } from '@angular/core';
import { OrganisationListItem } from '@assetaccountant/api/models/organisation-list-item';
import { RegisterDto } from '@assetaccountant/api/models/register.dto';
import { OrganisationV2Api } from '@assetaccountant/api/services/organisation-v2.api';
import { TypedFormControl, TypedFormGroup } from '@assetaccountant/core/utils/typed-forms';

@Component({
  selector: 'app-select-integration-register',
  templateUrl: './select-integration-register.component.html',
  styleUrls: ['./select-integration-register.component.scss'],
  standalone: false,
})
export class SelectIntegrationRegisterComponent implements OnInit {
  @Input() formGroup: TypedFormGroup<{
    organisationId: TypedFormControl<number | null>;
    registerId: TypedFormControl<number | null>;
  }>;

  organisations: OrganisationListItem[];
  registers: RegisterDto[];
  isLoadingOrganisations = false;
  isLoadingRegisters = false;

  constructor(private organisationsApi: OrganisationV2Api) {}

  ngOnInit() {
    this.isLoadingOrganisations = true;
    this.formGroup.controls.organisationId.disable();
    this.formGroup.controls.registerId.disable();
    this.organisationsApi.listOrganisations2().subscribe(({ result }) => {
      this.formGroup.controls.organisationId.enable();
      const organisations = result;
      this.organisations = organisations;

      if (organisations.length === 1) {
        this.formGroup.controls.organisationId.setValue(this.organisations[0].organisationId);
        this.onOrganisationSelected();
      }

      this.isLoadingOrganisations = false;
    });
  }

  onOrganisationSelected() {
    this.formGroup.controls.registerId.disable();
    this.isLoadingRegisters = true;

    if (!this.formGroup.value.organisationId) {
      return;
    }

    this.organisationsApi
      .listRegisters(this.formGroup.value.organisationId)
      .subscribe(listRegistersResponse => {
        this.formGroup.controls.registerId.enable();
        const registers = listRegistersResponse.registers.filter(
          register => !register.integrations.some(i => i.isPrimary) && !register.isDemo,
        );
        this.registers = registers;

        if (registers.length === 1) {
          this.formGroup.controls.registerId.setValue(this.registers[0].id);
        }

        this.isLoadingRegisters = false;
      });
  }
}
